import React, { type FC } from 'react'

import { getIsDefaultThumbnail } from 'helpers/getIsDefaultThumbnail'

import classNames from 'classnames'
import { ShareButton } from 'features/viewerPage/components/CTASection/Buttons/ShareButton'
import { StreamInfo, TopActionsBar, TeamVsTeamBackground } from '../'

import { type GameWithoutLivestream } from '../../types'

import styles from './StreamOverview.module.scss'

type StreamOverviewProps = {
  mediaObject: GameWithoutLivestream
}

export const StreamOverview: FC<StreamOverviewProps> = ({ mediaObject }) => {
  const isDefaultThumbnail =
    mediaObject.thumbnail && getIsDefaultThumbnail(mediaObject?.thumbnail)
  const shouldShowTeamsBackgrouns = isDefaultThumbnail && mediaObject

  return (
    <div
      className={classNames(styles.StreamOverview, {
        [styles.HasTeamVsTeamBackgrond]: shouldShowTeamsBackgrouns
      })}
    >
      <div className={styles.Background}>
        <div className={styles.Overlay}>
          <TopActionsBar />
          <div className={styles.InnerContainer}>
            <StreamInfo mediaObject={mediaObject} />
            <div className={styles.Container}>
              <div className={styles.InteractionButtonContainer}>
                <ShareButton />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.Background}>
          <div className={styles.TeamVsTeamBackground}>
            <TeamVsTeamBackground mediaObject={mediaObject} />
          </div>
        </div>
      </div>
    </div>
  )
}
